import { memo } from 'react';

const ScrollToTop = memo(() => {
  return (
    <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center">
      <i className="bi bi-arrow-up-short"></i>
    </a>
  );
});

ScrollToTop.displayName = 'ScrollToTop';

export default ScrollToTop;